import React, { FunctionComponent, useEffect } from 'react';
import { Navigate } from 'react-router';

import { useGetCustomerAccountQuery } from 'src/api/@generated/backend-api';

import { i18n } from 'src/i18n';
import { ChooseContainer } from 'src/components/choose-container';
import { Spinner } from 'src/components/spinner';
import { NavigationService } from 'src/services/navigation-service';
import { selectAccountActionCreator } from 'src/state/account/action-creators/select-account-action-creator';
import { selectSelectedAccount } from 'src/state/account/selectors';
import { goToStepActionCreator } from 'src/state/order/action-creators/go-to-step-action-creator';
import { OrderStep } from 'src/state/order/types';
import { useAppDispatch, useAppSelector } from 'src/state/thunk-api';
import { withOrderStep } from 'src/hocs/with-order-step';

import { ChooseAccountButton } from './choose-account-button';

const ChooseAccountPageComponent: FunctionComponent = () => {
  const { data: accounts, isLoading } = useGetCustomerAccountQuery();
  const selectedAccount = useAppSelector(selectSelectedAccount);
  const dispatch = useAppDispatch();
  const hasOnlyOneAccount = accounts && accounts.length === 1;

  useEffect(() => {
    if (hasOnlyOneAccount) {
      if (!selectedAccount) {
        dispatch(selectAccountActionCreator(accounts[0]));
      }
      dispatch(goToStepActionCreator(OrderStep.CHOOSE_SERVICE_LOCATION, true));
    }
  }, [accounts, dispatch, hasOnlyOneAccount, selectedAccount]);

  if (isLoading || hasOnlyOneAccount) {
    return <Spinner />;
  }

  if (accounts?.length === 0) {
    return <Navigate to={NavigationService.ERROR_NOT_AVAILABLE} replace={true} />;
  }

  return (
    <ChooseContainer title={i18n.page.chooseAccount.title} subTitle={i18n.page.chooseAccount.description}>
      {accounts?.map((account) => <ChooseAccountButton key={account.customerId} account={account} />)}
    </ChooseContainer>
  );
};

export const ChooseAccountPage = withOrderStep(OrderStep.CHOOSE_ACCOUNT)(ChooseAccountPageComponent);
